import React, { useEffect } from 'react';
import * as S from './card-header-photo.style';
import { formatCurrency } from '../../../../../common/utils/format-currency';
import { useTranslation } from 'react-i18next';
import { Checkout } from '../../../../../common/types/checkout';

type Props = {
  checkout: Checkout;
};

export const CardHeaderPhoto: React.FC<Props> = ({ checkout }) => {
  const { t } = useTranslation();
  useEffect(() => {
    console.log('checkout?.checkoutConfig?.config?.checkoutData?.checkoutHeader\n' +
      '              ?.subtitleColor', checkout?.checkoutConfig?.config?.checkoutData?.checkoutHeader
        ?.subtitleColor)
  }, [checkout]);
  return (
    <S.CardHeader>
      <S.ProductThumbnail
        src={
          checkout?.checkoutConfig?.config?.checkoutData?.checkoutHeader?.image
        }
        alt="Product Image"
      />
      <div>
        <h2>
          {checkout?.checkoutConfig?.config?.checkoutData?.checkoutHeader?.text}
        </h2>
        <S.Price
          color={
            checkout?.checkoutConfig?.config?.checkoutData?.checkoutHeader
              ?.subtitleColor
          }
        >
          {formatCurrency(checkout?.total, checkout?.moeda)} {t('cashPayment')}
        </S.Price>
      </div>
    </S.CardHeader>
  );
};
